import React, { useState } from 'react';
import { Box, Paper } from '@mui/material';
import ColorForm from '../components/color/ColorForm';
import ColorTable from '../components/color/ColorTable';

const ColorPage = () => {
  const [selectedColor, setSelectedColor] = useState(null);

  const handleEdit = (color) => {
    setSelectedColor(color);
  };

  const handleFormReset = () => {
    setSelectedColor(null);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'flex-start',
        width: '100%',
        flexWrap: { xs: 'wrap', md: 'nowrap' }, 
        p: 2,
      }}
    >
      {/* Table - Left Side */}
      <Paper
        elevation={3}
        sx={{
          flex: 2,
          p: 2,
          minWidth: 0,
        }}
      >
        <ColorTable onEdit={handleEdit} />
      </Paper>

      {/* Form - Right Side */}
      <Paper
        elevation={3}
        sx={{
          flex: 1,
          p: 2,
          minWidth: 300,
        }}
      >
        <ColorForm
          selectedColor={selectedColor}
          onReset={handleFormReset}
        />
      </Paper>
    </Box>
  );
};

export default ColorPage;
